/* eslint-disable @typescript-eslint/naming-convention */

/**
 * A function to get the returnTo back after returning from redirect
 *
 * Note: by default state should be present, but it can be undefined
 * if it is modified in the `AuthGuard` params
 * @param user
 * @returns `state`
 */
export function getCallbackState(user) {
  return user === null || user === void 0 ? void 0 : user.state;
}

/**
 * Provide this function to `UiPathAuthProvider` if no custom callback logic is needed.
 * Otherwise, use `getCallbackState` to get the `returnTo` and redirect to that route
 * on the callback through your router.
 *
 * Note: this function takes `navigate` as a param to avoid adding `react-router` as a dependency
 * @param user
 * @param navigate `router.navigate` for react router v6, `history.push` otherwise
 */
export function onCallback(user, navigate) {
  var _getCallbackState$ret, _getCallbackState;
  var returnTo = (_getCallbackState$ret = (_getCallbackState = getCallbackState(user)) === null || _getCallbackState === void 0 ? void 0 : _getCallbackState.returnTo) !== null && _getCallbackState$ret !== void 0 ? _getCallbackState$ret : '/portal_/cloudrpa';
  navigate(returnTo);
}